:host {
  display: block;
  max-width: 100%;
}

.action-icon {
  display: inline-block;

  &:before {
    font-size: 32px;
  }
}

.page__header {
  padding: calc(1.44 * var(--spacer)) calc(2 * var(--spacer)) calc(1.44 * var(--spacer)) calc(2.5 * var(--spacer));
  line-height: 33px;
}

gz-button[id*='deleteButton'][disabled] {
  opacity: 0.3;
}
